import { IndexData } from "@/features_signal/indexData"
import styled from "@emotion/styled"
import { Fragment } from "react"
import { CategoryGameList } from "../components/CategoryGameList"
import { FollowUs } from "../components/FollowUs"
import { ResponsibleGaming } from "../components/ResponsibleGaming"
import AppSignals from "@/features_signal/app"

const SubContainer = styled.section`
    padding-top: 10rem;
`

const order = [
    "Hot Games",
    "Slot",
    "Live",
    "Fishing",
    "Board Game",
    "Table Game",
    "Bingo",
    "New Games",
]

export const SubPageForYou = () => {
    return (
        <SubContainer>
            {Object.entries(IndexData.dataList.value)
                .sort(([keyA], [keyB]) => order.indexOf(keyA) - order.indexOf(keyB))
                .map(([title, list], idx) => {
                    if (["New Games", "Bingo", "Board Game", "Table Game"].includes(title)) {
                        return null
                    }
                    return (
                        <Fragment key={`${idx}_${title}_game`}>
                            <CategoryGameList
                                title={title}
                                link={
                                    ["Hot Games"].includes(title)
                                        ? `/s-game/sections/${title}`
                                        : `/s-game/category/${title}?sort=Popular`
                                }
                                games={list}
                            />
                        </Fragment>
                    )
                })}
            {AppSignals.isMayaminiUser() ? "" : <FollowUs />}
            <ResponsibleGaming />
        </SubContainer>
    )
}
